/*
 * @Description:
 * @Version: 2.0
 * @Autor: shimnx
 * @Date: 2021-08-04 09:07:37
 * @LastEditors: shimnx
 * @LastEditTime: 2021-08-12 13:48:50
 */
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Router, Routes, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { Observable, Subscription, interval } from 'rxjs';
import { filter, map, mergeMap, takeUntil } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { LoadingServiceT } from './common-loading.service';
@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>
  <app-common-loading [isLoading]="isLoading"></app-common-loading>`
})
export class AppComponent implements OnInit {
  title = 'app';
  currentPath: string = '';
  routeTitle: string = '';
  isLoading: boolean = false;
  private loadingSubscription: Subscription;
  private navEnd: Observable<NavigationEnd>;
  constructor(
    public translate: TranslateService,
    private router: Router,
    private loadingServiceT: LoadingServiceT,
    private activateRoute: ActivatedRoute,
    private titleServe: Title
  ) {
    this.currentPath = this.router.url.substring(this.router.url.lastIndexOf('/') + 1);
    this.navEnd = this.router.events.pipe(
      filter((evt) => evt instanceof NavigationEnd)
    ) as Observable<NavigationEnd>;
    // this.setTitle();
  }
  // routers: Routes = (this.router.config[0] as any)!._loadedConfig.routes[0].children;
  ngOnInit() {
    // this.routers = this.routers.splice(1, this.routers.length + 1);
    this.loadingSubscription = this.loadingServiceT.isLoading$.subscribe(status => {
        this.isLoading = status;
    });
  }
  private setTitle() {
    this.navEnd
      .pipe(
        map(() => this.activateRoute),
        map((route: ActivatedRoute) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        mergeMap((route) => route.data)
      )
      .subscribe((data: any) => {
        this.routeTitle = data.tit;
        this.titleServe.setTitle(this.routeTitle);
      });
  }
}
